<template>
  <div>
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="row common-margin-top common-margin-bottom">
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px"
                       :to="{path:'/interface/zysm'}" type="button"
                       class="font-10 btn btn-danger">重要说明
          </router-link>
        </div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px"
                       :to="{path:'/interface/sm'}" type="button"
                       class="font-10 btn btn-info">扫码支付
          </router-link>
        </div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/gzh'}" type="button" class="font-10 btn btn-info">公众号付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/xcx'}" type="button" class="font-10 btn btn-info">小程序付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/tm'}" type="button" class="font-10 btn btn-info">条码支付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/app'}" type="button" class="font-10 btn btn-info">APP支付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/sl'}" type="button" class="font-10 btn btn-info">刷脸支付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/fz'}" type="button" class="font-10 btn btn-info">分账</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/qb'}" type="button" class="font-10 btn btn-info">代付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/zshbj'}" type="button" class="font-10 btn btn-info">商户报件</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/kj/kjkys'}" type="button" class="font-10 btn btn-info">快捷支付</router-link></div>
        <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/tyxd'}" type="button" class="font-10 btn btn-info">统一下单</router-link></div>
        <!-- <div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
          <router-link tag="button" style="width: 80px" :to="{path:'/interface/acct/userreg'}" type="button" class="font-10 btn btn-info">钱包</router-link></div> -->
      <!--<div class="col col-4 col-md-2 col-lg-2 common-margin-top-1">
        <router-link tag="button" style="width: 80px" :to="{path:'/interface/fj'}" type="button" class="font-10 btn btn-info">附加接口</router-link></div>-->
      </div>
      <div class="bg-white">
        <router-view name="interfacePage"> </router-view>
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'

export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '支付接口',
        url: '#',
        describe: '扫码支付、公众号支付、小程序支付' +
          '    条码支付、APP支付、刷脸支付、分账接口' +
          '    钱包代付、子商户报件、附加接口......'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/Interface.vue